export const DS_PAGE_COLUMN_SLOT_PATTERN = /^column-[1-9]\d*$/;
